import { useEffect, useState } from 'react';
import { useSpace } from '../../../context';
import { SpaceButton } from './SpaceButton';
import { SpaceMenu } from './SpaceMenu';

function SpaceSwitcher() {
  const { spaceCode, spaceName, spaceOptions, loadSpaceOptions, setSpace, addSpace } = useSpace();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  // ボタンに候補の件数を出すので、開く前（mount したとき）に読み込む。
  useEffect(() => {
    void loadSpaceOptions();
  }, [loadSpaceOptions]);

  return (
    <>
      <SpaceButton
        spaceName={spaceName}
        spaceCount={spaceOptions.length}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
      />
      <SpaceMenu
        spaceCode={spaceCode}
        spaceOptions={spaceOptions}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        onSelect={setSpace}
        onCreate={addSpace}
      />
    </>
  );
}

export { SpaceSwitcher };
